// Health programs marketplace client.
import { API_BASE } from './chat'

export type ProgramItem = { id: string; category: string; name: string; partner: string; description: string }
export type Enrollment = { id: number; program_id: string; label: string; status: string; created_at: string }

export async function getProgramsCatalog(): Promise<ProgramItem[]> {
  try {
    const r = await fetch(`${API_BASE}/v1/programs/catalog`)
    return r.ok ? (await r.json()).catalog : []
  } catch {
    return []
  }
}

export async function getEnrollments(userId: string): Promise<Enrollment[]> {
  try {
    const r = await fetch(`${API_BASE}/v1/programs/enrollments?user_id=${encodeURIComponent(userId)}`)
    return r.ok ? (await r.json()).enrollments : []
  } catch {
    return []
  }
}

export async function enrollProgram(userId: string, programId: string): Promise<boolean> {
  try {
    const r = await fetch(`${API_BASE}/v1/programs/enroll`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, program_id: programId }),
    })
    return r.ok
  } catch {
    return false
  }
}
